Pixlee.module('CoverflowApp', function(CoverflowApp, _App, _Backbone, _Marionette, _$) {
    CoverflowApp.on("start", function(options) {
        new CoverflowApp.Show.Controller(options);
    });
});
